<template>
 <div>
    <!-- <el-button
      @click="daochu"
      type="primary"
      style="background: #f78989; border-color: #f78989; margin-bottom: 20px"
      >导出</el-button
    > -->
  <el-tabs v-model="tabkey" @tab-click="handleClick">
    <el-tab-pane label="开票进度" name="reportOfInvoice">
      <el-table :data="list" border style="width: 100%;margin-bottom:20px;" stripe>
        <el-table-column prop="customerOrderNo" label="客户订单号"> </el-table-column>
        <el-table-column prop="orderNo" label="订单编号"> </el-table-column>
        <el-table-column prop="deliveryCode" label="发货单号"> </el-table-column>
        <el-table-column prop="customerCode" label="下单客户编码"> </el-table-column>
        <el-table-column prop="customerName" label="下单客户名称"> </el-table-column>
        <el-table-column prop="invoiceCustomerCode" label="开票客户编码"> </el-table-column>
        <el-table-column prop="invoiceCustomerName" label="开票客户名称"> </el-table-column>
        <el-table-column prop="totalAmount" label="合计净额"> </el-table-column>
        <el-table-column prop="invoiceCode" label="发票号"> </el-table-column>
        <el-table-column prop="invoiceAmount" label="开票金额"> </el-table-column>
        <el-table-column prop="sellType" label="销售类别"> </el-table-column>
        <el-table-column prop="num" label="数量"> </el-table-column>
        <el-table-column prop="weight" label="重量"> </el-table-column>
        <el-table-column prop="productType" label="产品类型"> </el-table-column>
        <el-table-column prop="invoiceType" label="开票类型"> </el-table-column>
        <el-table-column prop="labourName" label="劳务名称"> </el-table-column>
        <el-table-column prop="unit" label="计量单位"> </el-table-column>
        <el-table-column prop="invoiceNote" label="开票备注"> </el-table-column>
        <el-table-column prop="invoiceDesc" label="开票说明"> </el-table-column>
        <el-table-column prop="invoiceTime" label="开票时间"> </el-table-column>
        <el-table-column prop="postFlag" label="是否邮寄"> </el-table-column>
        <el-table-column prop="postOrderId" label="邮寄单号"> </el-table-column>
        <el-table-column prop="logisticsInfo" label="物流信息"> </el-table-column>
        <el-table-column prop="qsFlag" label="是否签收"> </el-table-column>
      </el-table>
    </el-tab-pane>
    <el-tab-pane label="欠款" name="reportOfQkTotal">
      <el-table :data="list" border style="width: 100%;margin-bottom:20px;" stripe @row-dblclick="handleCheckDebt">
        <el-table-column prop="customerCode" label="下单客户编码"> </el-table-column>
        <el-table-column prop="customerName" label="下单客户名称"> </el-table-column>
        <el-table-column prop="maxDay" label="最大欠款天数"> </el-table-column>
        <el-table-column prop="amount" label="欠款总额"> </el-table-column>
        <el-table-column prop="zeroToWarn" label="0-预警期"> </el-table-column>
        <el-table-column prop="warn" label="预警期"> </el-table-column>
        <el-table-column prop="outTime" label="超付款周期"> </el-table-column>
        <el-table-column prop="clear" label="清欠期"> </el-table-column>
      </el-table>
    </el-tab-pane>
    <el-tab-pane label="回款" name="reportOfCollect">
      <el-table :data="list" border style="width: 100%;margin-bottom:20px;" stripe>
        <el-table-column prop="customer" label="下单客户"> </el-table-column>
        <el-table-column prop="payCustomer" label="付款客户"> </el-table-column>
        <el-table-column prop="invoiceType" label="单据类型"> </el-table-column>
        <el-table-column prop="payType" label="来款方式"> </el-table-column>
        <el-table-column prop="collectAmount" label="收款金额"> </el-table-column>
        <el-table-column prop="collectAmountFact" label="实收金额"> </el-table-column>
        <el-table-column prop="verificationAmount" label="已核销金额"> </el-table-column>
        <el-table-column prop="collectDate" label="收款日期"> </el-table-column>
        <el-table-column prop="collectBank" label="收款银行"> </el-table-column>
        <el-table-column prop="collectCompany" label="收款公司"> </el-table-column>
        <el-table-column prop="currency" label="币种"> </el-table-column>
        <el-table-column prop="adjustFlag" label="是否调账"> </el-table-column>
        <el-table-column prop="adjustCustomer" label="调账客户"> </el-table-column>
        <el-table-column prop="updateUser" label="最后修改人"> </el-table-column>
      </el-table>
    </el-tab-pane>
    <el-tab-pane label="对账单" name="reportOfAccount">
      <el-table :data="list" border style="width: 100%;margin-bottom:20px;" stripe>
        <el-table-column prop="orgId" label="账套ID"> </el-table-column>
        <el-table-column prop="orgName" label="账套名称"> </el-table-column>
        <el-table-column prop="customerCode" label="下单客户编码"> </el-table-column>
        <el-table-column prop="customerName" label="下单客户名称"> </el-table-column>
        <el-table-column prop="invoiceCode" label="开票客户编码"> </el-table-column>
        <el-table-column prop="invoiceName" label="开票客户名称"> </el-table-column>
        <el-table-column prop="accountYear" label="对账年度"> </el-table-column>
        <el-table-column prop="accountMonth" label="对账月份"> </el-table-column>
        <el-table-column prop="startAmount" label="初期金额"> </el-table-column>
        <el-table-column prop="deliveryNum" label="发货数量"> </el-table-column>
        <el-table-column prop="deliveryWeight" label="发货重量"> </el-table-column>
        <el-table-column prop="totalAmount" label="总金额"> </el-table-column>
        <el-table-column prop="backAmount" label="回款额"> </el-table-column>
        <el-table-column prop="endAmount" label="期末金额"> </el-table-column>
      </el-table>
    </el-tab-pane>
    <el-tab-pane label="接单进度" name="reportOfGetOrder">
      <el-table :data="list" border style="width: 100%;margin-bottom:20px;" stripe>
        <el-table-column prop="customerCode" label="下单客户编码"> </el-table-column>
        <el-table-column prop="customerName" label="下单客户名称"> </el-table-column>
        <el-table-column prop="sellType" label="销售类别"> </el-table-column>
        <el-table-column prop="year" label="年度"> </el-table-column>
        <el-table-column prop="season" label="季度"> </el-table-column>
        <el-table-column prop="month" label="月度"> </el-table-column>
        <el-table-column prop="weight" label="重量"> </el-table-column>
        <el-table-column prop="amount" label="总计金额"> </el-table-column>
        <el-table-column prop="zkAmount" label="市场折扣额"> </el-table-column>
        <el-table-column prop="deliveryAmount" label="发货额"> </el-table-column>
        <el-table-column prop="weigthGoalYear" label="年度重量目标"> </el-table-column>
        <el-table-column prop="weigthGoalSeason" label="季度重量目标"> </el-table-column>
        <el-table-column prop="weigthGoalMonth" label="月度重量目标"> </el-table-column>
        <el-table-column prop="amountGoalYear" label="年度金额目标"> </el-table-column>
        <el-table-column prop="amountGoalSeason" label="季度金额目标"> </el-table-column>
        <el-table-column prop="amountGoalMonth" label="月度金额目标"> </el-table-column>
      </el-table>
    </el-tab-pane>
    <el-tab-pane label="销售进度" name="reportOfSellSchedule">
      <el-table :data="list" border style="width: 100%;margin-bottom:20px;" stripe>
        <el-table-column prop="customerCode" label="开单客户编码"> </el-table-column>
        <el-table-column prop="customerName" label="开单客户名称"> </el-table-column>
        <el-table-column prop="sellType" label="销售类别"> </el-table-column>
        <el-table-column prop="year" label="年度"> </el-table-column>
        <el-table-column prop="season" label="季度"> </el-table-column>
        <el-table-column prop="month" label="月度"> </el-table-column>
        <el-table-column prop="weight" label="重量"> </el-table-column>
        <el-table-column prop="totalAmount" label="总计金额"> </el-table-column>
        <el-table-column prop="syzkAmount" label="商业折扣额"> </el-table-column>
        <el-table-column prop="sczkAmount" label="市场折扣额"> </el-table-column>
        <el-table-column prop="projectFee" label="项目销售费用"> </el-table-column>
        <el-table-column prop="deliveryAmount" label="发货额"> </el-table-column>
        <el-table-column prop="weigthGoalYear" label="重量目标-年度"> </el-table-column>
        <el-table-column prop="weigthGoalSeason" label="重量目标-季度"> </el-table-column>
        <el-table-column prop="weigthGoalMonth" label="重量目标-月度"> </el-table-column>
        <el-table-column prop="amountGoalYear" label="发货额目标-年度"> </el-table-column>
        <el-table-column prop="amountGoalSeason" label="发货额目标-季度"> </el-table-column>
        <el-table-column prop="amountGoalMonth" label="发货额目标-月度"> </el-table-column>
      </el-table>
    </el-tab-pane>
    <el-tab-pane label="折扣达成进度" name="reportOfZkFinish">
      <el-table :data="list" border style="width: 100%;margin-bottom:20px;" stripe>
        <el-table-column prop="customerCode" label="下单客户编码"> </el-table-column>
        <el-table-column prop="customerName" label="下单客户名称"> </el-table-column>
        <el-table-column prop="policyCode" label="政策编号"> </el-table-column>
        <el-table-column prop="product" label="产品"> </el-table-column>
        <el-table-column prop="startDate" label="开始日期"> </el-table-column>
        <el-table-column prop="endDate" label="截止日期"> </el-table-column>
        <el-table-column prop="weight" label="重量"> </el-table-column>
        <el-table-column prop="zkAmount" label="折扣额"> </el-table-column>
        <el-table-column prop="sczkAmount" label="市场折扣额"> </el-table-column>
        <el-table-column prop="projectFee" label="项目销售费用"> </el-table-column>
        <el-table-column prop="totalAmount" label="总计金额"> </el-table-column>
        <el-table-column prop="deliveryAmount" label="发货额"> </el-table-column>
        <el-table-column prop="weightGoal" label="目标-重量"> </el-table-column>
        <el-table-column prop="deliveryGoal" label="目标-发货额"> </el-table-column>
        <el-table-column prop="weightDiff" label="重量-差额"> </el-table-column>
        <el-table-column prop="deliveryDiff" label="发货额-差额"> </el-table-column>
      </el-table>
    </el-tab-pane>
    <el-tab-pane label="折扣发放进度" name="reportOfZkDelivery">
      <el-table :data="list" border style="width: 100%;margin-bottom:20px;" stripe>
        <el-table-column prop="customerCode" label="下单客户编码"> </el-table-column>
        <el-table-column prop="customerName" label="下单客户名称"> </el-table-column>
        <el-table-column prop="policyCode" label="政策编号"> </el-table-column>
        <el-table-column prop="sellType" label="销售类别"> </el-table-column>
        <el-table-column prop="zkType" label="折扣类型"> </el-table-column>
        <el-table-column prop="zkAmount" label="折扣额"> </el-table-column>
        <el-table-column prop="deliveryAmount" label="发放额"> </el-table-column>
        <el-table-column prop="surplusAmount" label="剩余额"> </el-table-column>
        <el-table-column prop="deliveryStartDate" label="发放开始日期"> </el-table-column>
        <el-table-column prop="deliveryEndDate" label="发放截止日期"> </el-table-column>
      </el-table>
    </el-tab-pane>
  </el-tabs>
  <el-pagination
    :current-page="pageNo"
    :page-size="pageSize"
    background
    layout="prev, pager, next, jumper"
    :total="rowCount"
    @current-change="handleCurrentChange"
  />
 </div>
</template>

<script>
export default {
  created() {
    this.getList()
  },
      methods:{
        getList() {
          this.$axios
            .postReq("/meide/REST/ajaxReports", {
              postType: this.tabkey,
              start: this.pageNo,
              limit: this.pageSize
            })
            .then((res) => {
              this.list = res.data;
              this.rowCount = res.rowcount;
            });
        },
        handleCurrentChange(val) {
          this.pageNo = val;
          this.getList();
        },
        handleCheckDebt(item) {
          const path = this.$router.resolve({
            name: "DebtDetail",
            params:{
              code:item.customerCode
            }
          });
          window.open(path.href, "_blank");
        },
        handleClick(tab, event) {
          this.tabkey = tab.props.name
          this.pageNo = 1
          this.getList()
        }
    //       daochu() {
    // let invoiceSeq = this.$route.params.id;
    //   this.$axios
    //     .postReq("/meide/REST/ajaxOrderExport", {
    //       postType: "exportInvoiceDetail",
    //       invoiceSeq,
    //     })
    //     .then((res) => {
    //       if (res.success == "true") {
    //         let url = res.url;
    //         window.open(url);
    //       } else {
    //         // this.$message.error(res.ErrorText);
    //       }
    //     });
    // },
    },
  data() {
    return {
      list: [],
      pageNo: 1,
      pageSize: 10,
      rowCount: 0,
      tabkey: 'reportOfInvoice'
    };
  },
};
</script>